import { CssBaseline } from "@mui/material";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import HomePage from "./page";
import { trackPageView } from "./utils/Convert";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const theme = createTheme({});

function App() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever the location changes
    trackPageView(location.pathname);
  }, [location]);

  useEffect(() => {
    // Add Convert.com SPA initialization
    const handleConvertFinish = () => {
      // This event tells Convert.com that your SPA has finished loading
      if (window.convert && typeof window.convert.initReady === "function") {
        window.convert.initReady();
      }
    };

    window.addEventListener("convert:finish", handleConvertFinish);

    // Also trigger initReady on initial load
    if (window.convert && typeof window.convert.initReady === "function") {
      window.convert.initReady();
    }

    // Clean up listener when component unmounts
    return () => {
      window.removeEventListener("convert:finish", handleConvertFinish);
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HomePage />
    </ThemeProvider>
  );
}

export default App;
